import { App } from '../types';

/**
 * Recipe Labs Applications Configuration
 *
 * This file contains the configuration for all Recipe Labs applications.
 *
 * STYLE GUIDE:
 * - Icons must be SVG identifiers (NO emojis allowed)
 * - Icon values map to components in src/components/icons/AppIcons.tsx
 *
 * Each app should include:
 * - id: unique identifier
 * - name: display name
 * - description: brief description of the app
 * - icon: SVG icon identifier (e.g., 'flask', 'target', 'mail-open')
 * - url: launch URL for the application
 * - status: current status (active, development, maintenance, deprecated)
 * - category: categorization (AI Tools, Client Tools, Internal Tools, MCP Servers)
 * - tags: optional search tags
 * - version: optional version string
 * - lastUpdated: optional last update timestamp
 */

export const apps: App[] = [
  // Official Recipe Labs Apps - madebyrecipe.com subdomains only
  {
    id: 'recipe-labs-platform',
    name: 'AI Toolbox',
    description: 'Your one-stop shop for all our AI tools. Write better, research faster, and get more done with 16+ smart assistants.',
    icon: 'flask',
    url: 'https://recipelabs.madebyrecipe.com',
    status: 'active',
    category: 'ai-tools',
    tags: ['ai', 'platform', 'tools', 'marketing'],
    version: '1.0.0',
    lastUpdated: '2024-12-23'
  },
  {
    id: 'lead-generator',
    name: 'Find New Clients',
    description: 'Quickly discover potential customers and get their contact info. Perfect for growing your client list without cold calling.',
    icon: 'target',
    url: 'https://leadgen.madebyrecipe.com',
    status: 'active',
    category: 'ai-tools',
    tags: ['leads', 'sales', 'ai', 'prospecting'],
    version: '1.0.0',
    lastUpdated: '2024-12-23'
  },
  {
    id: 'email-builder',
    name: 'Email Writer',
    description: 'Create professional emails in seconds. Just describe what you need and get ready-to-send messages that sound great.',
    icon: 'mail-open',
    url: 'https://emailbuilder.madebyrecipe.com',
    status: 'active',
    category: 'client-tools',
    tags: ['email', 'templates', 'marketing', 'copywriting'],
    version: '1.0.0',
    lastUpdated: '2024-12-23'
  },
  {
    id: 'media-scraper',
    name: 'Social Media Research',
    description: 'See what people are saying on social media. Great for understanding trends, competitors, and what your audience cares about.',
    icon: 'search-scan',
    url: 'https://scraper.madebyrecipe.com',
    status: 'active',
    category: 'ai-tools',
    tags: ['scraping', 'social media', 'research', 'data'],
    version: '1.0.0',
    lastUpdated: '2024-12-23'
  },
  {
    id: 'playbook-generator',
    name: 'Strategy Builder',
    description: 'Build step-by-step plans and guides for any project. Turn your ideas into clear action plans everyone can follow.',
    icon: 'book-text',
    url: 'https://playbook.madebyrecipe.com',
    status: 'active',
    category: 'client-tools',
    tags: ['playbook', 'strategy', 'documentation', 'ai'],
    version: '1.0.0',
    lastUpdated: '2024-12-23'
  },
  {
    id: 'guide-site',
    name: 'Help & Tutorials',
    description: 'Learn how to use all our tools with easy guides and video tutorials. Get answers to common questions here.',
    icon: 'file-text',
    url: 'https://guide.madebyrecipe.com',
    status: 'active',
    category: 'internal',
    tags: ['documentation', 'guides', 'help', 'resources'],
    version: '1.0.0',
    lastUpdated: '2024-12-23'
  }
];

export default apps;
